
import React from "react";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { AlertCircle } from "lucide-react";

export const AccessDeniedAlert = () => {
  return (
    <div className="space-y-6">
      <div className="flex flex-col">
        <h1 className="text-3xl font-bold text-gray-900">Calculadora de Gastos</h1>
        <p className="text-muted-foreground">Calcule sus gastos de servicios y gastos comunes</p>
      </div>
      
      <Alert variant="destructive">
        <AlertCircle className="h-4 w-4" />
        <AlertTitle>Acceso Restringido</AlertTitle>
        <AlertDescription>
          Esta calculadora es solo para administradores.
        </AlertDescription>
      </Alert>
    </div>
  );
};
